export default {
	tenantId: "vertex_demo",
	appId: "admin_portal"
}
